module.exports = __webpack_public_path__ + "static/media/header2.c06964ec.png";